export const USER_ID = "user_id";
export const ALTERNATE_LOGIN_ID = "loginId";
export const FIRST_NAME = "firstName";
export const LAST_NAME = "lastName";
export const MOBILE_NO = "phoneNumber";
export const LANDLINE_NO = "landlineNumber";
export const EMAIL_ID_1 = "email";
export const EMAIL_ID_2 = "email2";
export const ADDRESS = "address";
export const ADDRESS_1 = "addressLine1";
export const ADDRESS_2 = "addressLine2";
export const ZIPCODE = "zipCode";
export const STATE = "state";
export const CITY = "city";
export const PO_BOX = "pobox";
export const OCCUPANCY_TYPE = "occupancyType";
export const START_DATE = "startDate";
export const END_DATE = "endDate";
export const IS_BOM_USER = "isBomUser";
export const BOM_START_DATE = "bomStartDate";
export const BOM_END_DATE = "bomEndDate";
export const BOM_POSITION = "bomPositionId";
export const USERNAME = "userName";
export const CORRESPONDENCE_ADDRESS = "correspondenceAddress";

export const occupancyTypes = [
  { label: "Owner", value: "owner" },
  // { label: "Tenant", value: "tenant" },
];

export const SMS_PAST_DUE = "smsForPastDue";
export const OPT_GENERAL = "optInGeneral";
export const OPT_EMERGENCY = "optInEmergency";
export const DISPLAY_NAME = "displayName";
export const PROP_ADDRESS = "displayPropAddress";
export const DISPLAY_EMAIL = "displayEmailAddress";
export const DISPLAY_MOBILE = "displayMobile";
export const DISPLAY_LANDLINE = "displayLandline";
export const ADS = "optInPartnerOnlineAds";
export const PARTNER_EMAIL = "optInPartnerEmails";
export const PREFERENCE_ID = "preferenceId";

export const ACCOUNT_ID = "accountDetailId";
export const PAYMENT_TYPE = "paymentType";
export const ZELLE_URL = "zelleUrl";
export const ACH_ROUTING = "achRouting";
export const ACH_ACCOUNT = "achAccount";
export const ACH_ACCOUNT_NAME = "achAccountName";
export const ACH_BANK_NAME = "achBankName";
export const E_ACCOUNT_NO = "eaccountNumber";
export const E_ACCOUNT_NAME = "eaccountName";
export const E_ACCOUNT_EMAIL = "eaccountEmail";
export const E_ACCOUNT_PHONE = "eaccountPhone";
export const E_COM_SIGNUP = "ecomSignup";
export const E_COM_START_DATE = "ecomStartDate";
export const AUTO_BILLING_ENROLL = "autoBillingEnrolled";
export const AUTO_BILLING_START_DATE = "autoBillingEnrolledDate";
export const AUTO_BILLING_LA = "autoBillingForLeaseAdmin";
export const AUTO_BILLING_LA_START_DATE = "autoBillingStartDate";
export const AUTO_BILLING_LA_END_DATE = "autoBillingEndDate";

export const PAYMENT_TYPE_OPTIONS = [
  { label: "Zelle", value: "ZELLE" },
  { label: "ACH", value: "ACH" },
  // { label: "E-Check", value: "E_CHECK" },
  // { label: "Debit Card", value: "DEBIT_CARD" },
  // { label: "Credit Card", value: "CREDIT_CARD" },
  // { label: "Bank Transfer", value: "BANK_TRANSFER" },
];
